export default {
  // 标题
  time: "时间",

  // 占位符
  pleaseSelect: "请选择",
  startDate: "开始日期",
  endDate: "结束日期",

  // 功能开关选项
  surveyData: "调证数据",
  firstInflow: "首笔流入",
  swapContract: "swap合约",

  // 消息提示
  currencyUpdateSuccess: "币种修改成功",
  timeUpdateSuccess: "时间修改成功",
  tagUpdateSuccess: "标签修改成功",
  switchUpdateSuccess: "开关修改成功",
  filterSuccess: "筛选成功",
  updateSuccess: "修改成功",
};
